import React, { useState, useEffect } from "react";
import Select from "react-select";

const SelectInputTrack = ({
  id,
  label,
  onChange,
  name,
  className,
  error,
  optionsSelect,
  isOpen,
  value,
}) => {
  const [filteredOptions, setFilteredOptions] = useState(optionsSelect);
  const [selectedOption, setSelectedOption] = useState(null);

  const selectOptions = filteredOptions.map((provider) => ({
    value: provider.TrackID,
    label: `${provider.TrackCode} - ${provider.TrackName}`,
    trackCode: provider.TrackCode,
    providerID: provider.ProviderID,
  }));

  useEffect(() => {
    if (value !== undefined) {
      if (value === "" || value === null) {
        if (selectedOption !== null) {
          setSelectedOption(null);
        }
      } else {
        const match = selectOptions.find(
          (option) => option.trackCode === value,
        );
        if (match && match.value !== selectedOption?.value) {
          setSelectedOption(match);
        }
      }
    }
  }, [value, filteredOptions]);

  useEffect(() => {
    setFilteredOptions(optionsSelect);
    if (isOpen === false) {
      setSelectedOption(null);
    }
  }, [isOpen, optionsSelect]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    onChange(
      selectedOption?.value,
      selectedOption?.trackCode,
      selectedOption?.providerID || "",
      "",
      "",
    );
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: error ? "1px solid #dc3545" : "none",
      borderRadius: "0.25rem",
      boxShadow: "none",
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: 0,
    }),
    container: (provided) => ({
      ...provided,
      padding: 0,
    }),
  };

  return (
    <>
      <label className="lead" htmlFor={id}>
        {label}
      </label>

      <Select
        id={id}
        name={name}
        className={className}
        styles={customStyles}
        value={selectedOption}
        onChange={handleChange}
        options={selectOptions}
        placeholder="Select Track"
      />

      {error !== 0 && (
        <div
          className="mb-1"
          style={{
            marginTop: "0.25rem",
            fontSize: "80%",
            color: "#dc3545",
          }}
        >
          {error}
        </div>
      )}
    </>
  );
};

export default SelectInputTrack;
